import React, { Component } from 'react';
import { Menu } from 'antd';
import { NavLink } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import * as Icons from '@ant-design/icons';
import s from './style.module.less';
import { HomeOutlined } from '@ant-design/icons';
import { Display } from '../Display/Display';

@inject('store')
@observer
class SubMenu extends Component {
    getItem = (label, key, icon, children, type) => {
        return {
            key,
            icon: icon ? (Icons[icon] ? React.createElement(Icons[icon]) : React.createElement(Icons['DatabaseOutlined'])) : null,
            children,
            label,
            type
        };
    };
    getDefaultToPath = (item, side_url) => {
        if (item.resource_source === 2) {
            //低点码渲染
            return `/${side_url}/tenant/view/${item.page_key}`;
        }
        return `/${side_url}/${item.resource_path}`;
    };
    getNavLink = (item, side_url, menu) => {
        let toPath = '',
            target = false;
        //二级菜单跳转的逻辑
        // if (!item.resource_path && !item.page_key && item.children.length) {
        //     //给二级菜单一个默认跳转的地址
        //     toPath = this.getDefaultToPath(item.children[0], side_url);
        // } else {
        //     toPath = this.getDefaultToPath(item, side_url);
        // }
        //二级菜单不跳转
        if (!item.resource_path && !item.page_key && item.children?.length) {
            console.log(item, '错误的菜单');
            return (
                <a title={item.name}>
                    <Display show={item.resource_icon}>
                        <HomeOutlined></HomeOutlined>
                    </Display>
                    {item.name}
                </a>
            );
        }
        toPath = this.getDefaultToPath(item, side_url);

        if (item.resource_source === 4 && item.new_tab === 1) {
            //外链
            toPath = item.resource_path;
            target = '_blank';
            return (
                <a href={toPath} target={target}>
                    <Display show={item.resource_icon}>
                        <HomeOutlined></HomeOutlined>
                    </Display>{' '}
                    {item.name || item.resource_name}
                </a>
            );
        }

        return (
            <NavLink
                target={target}
                to={toPath}
                reloadDocument={toPath === window.location.pathname}
                onClick={() => {
                    this.onClickSubMenu(item);
                }}
            >
                {({ isActive }) => {
                    if (isActive) {
                        localStorage.setItem('item', JSON.stringify(item));
                    }
                    return (
                        <span className={menu.menuState.subSelectMenu.id === item.id ? s.isActive : ''}>
                            <Display show={item.resource_icon}>
                                <HomeOutlined style={{ marginRight: '2px' }}></HomeOutlined>
                            </Display>

                            {item.name || item.resource_name}
                        </span>
                    );
                }}
            </NavLink>
        );
    };
    getContent = () => {
        const { menu, global } = this.props.store,
            { side_url } = global.platform;
        let subMenus = menu.menuState.outSelectMenu.children || [];
        return (
            subMenus &&
            subMenus.map((item) => {
                return this.getItem(
                    this.getNavLink(item, side_url, menu),
                    item.id,
                    item.resourceIcon,
                    item.children &&
                    item.children.map((option) => {
                        return this.getItem(this.getNavLink(option, side_url, menu), option.id, null);
                    })
                );
            })
        );
    };

    dragMoveHandle = () => {
        const { menu } = this.props.store;

        menu.setHandleVisible(true);
    };
    //菜单展开收起
    onOpenChange = (keys) => {
        const { menu } = this.props.store;
        // let lastOpenKeys = menu.menuState.subMenuOpenKeys;
        // let newOpenKeys = [...new Set([...lastOpenKeys, ...keys])];
        menu.setMenuState({
            subMenuOpenKeys: keys
        });
    };
    //点击菜单
    onClickSubMenu = (menuInfo) => {
        const {
            store: { menu }
        } = this.props;
        menu.setMenuState({
            subSelectMenu: menuInfo
        });
    };
    render() {
        const { menu } = this.props.store;

        return (
            <div className={s['sub-menu-wrap']}>
                <div className={`${s.subMenu} subMenu`}>
                    <div className={s.quick}> {menu.menuState.outSelectMenu.name || menu.menuState.outSelectMenu.resource_name}</div>
                    <Menu
                        selectedKeys={[menu.menuState.subSelectMenu.id]}
                        onOpenChange={this.onOpenChange}
                        openKeys={menu.menuState.subMenuOpenKeys}
                        mode="inline"
                        items={this.getContent()}
                    />
                </div>
            </div>
        );
    }
}

export default SubMenu;
